module.exports = __webpack_public_path__ + "img/big.5aa8a668.jpg";